import { Link } from "react-router-dom";
import images from "../../assets/images/assets";
import Button1 from "../SmallComponents/Button1";
import SectionImage02 from "../SmallComponents/SectionImage02";
import cards from "../../assets/images/cards/cards";

const AboutSection = () => {
  return (
    <div className="bg-transparent w-full p-4  relative">
      <div className="bg-transparent p-4 md:p-8 h-screen col lg:flex-row lg:px-14  gap-5 text-prime-red">
        <div className="top col items-center lg:items-start gap-5 lg:mt-56">
          <div>
            <h3 className="uppercase montserrat text-center lg:text-left  lg:-mb-6">
              Our story
            </h3>

            <h2 className="playfair-display heading-1 lg:-mb-4">About us</h2>
          </div>

          <p className="montserrat text-center md:w-3/4 lg:w-[90%] mt-4  lg:text-left ">
            From the beginning, we&#39;ve believed invitations should show what
            makes your event special. We offer custom designs and a wide range
            of decorations. We want your invitations to make a great first
            impression and set the perfect mood for your celebration.
          </p>

          <Link to="/story">
            <Button1 title="Read about us" />
          </Link>
        </div>
        <div className="bottom md:px-20  flex-1 pt-10">
          <SectionImage02 image={cards.card_005} />
        </div>
      </div>

      {/* Decorative */}

      <img
        src={images.blur_2}
        alt="blur"
        className="absolute saturate-200 -left-40 -bottom-30  md:-bottom-40  md:-left-70 lg:-bottom-220 lg:-left-130 -z-[0]"
      />
    </div>
  );
};

export default AboutSection;
